import axios from 'axios';

const VITE_API_PATH = import.meta.env.VITE_API_PATH ?? 'access.wicketsoft.com';

const createAxiosInstance = (api: 'api' | 'api-reporting') => {
  const baseURL = `${location.protocol}//${VITE_API_PATH}/${api}`;

  return axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Apiversion: '1.9',
      Appplatform: 'web',
    },
  });
};

const axiosInstance = createAxiosInstance('api');
const axiosReportingInstance = createAxiosInstance('api-reporting');

export { axiosInstance, axiosReportingInstance };
